const isNumber = (maybeNumber) => {
  return typeof maybeNumber === "number";
};

const useActualWeight = (controlWeight) => (weight) => {
  return isNumber(weight) ? weight - controlWeight : undefined;
};

export const useDerivedWeights = ({
  controlWeight,
  contentWeight,
  donationPercentage,
  conformingWeight,
  assembledWeight,
  weightConverter,
}) => {
  const actualWeightCalc = useActualWeight(controlWeight);
  const actualContentWeight = actualWeightCalc(contentWeight);
  const actualConformingWeight = actualWeightCalc(conformingWeight);
  const actualAssembledWeight = actualWeightCalc(assembledWeight);

  // prettier-ignore
  const actualNonConformingWeight =
    isNumber(actualContentWeight) && isNumber(actualConformingWeight)
      ? Math.max(actualContentWeight - Math.max(actualWeightCalc(assembledWeight || 0), 0) - actualConformingWeight, 0)
      : "";

  const roundedNonConformingWeight =
    Math.round(actualNonConformingWeight * 100) / 100;

  // New payout calculation: PW = (TCW - NCW) * (1 - DP)
  // prettier-ignore
  const paymentWeight =
    isNumber(actualContentWeight) && isNumber(roundedNonConformingWeight)
      ? Math.max(
        weightConverter(actualContentWeight - roundedNonConformingWeight) * (1 - donationPercentage ),
        0
      )
      : 0;

  return {
    actualContentWeight,
    actualConformingWeight,
    actualAssembledWeight,
    paymentWeight,
    nonConformingWeight:
      // due to rounding to 2dp, we could end up with negative 0
      roundedNonConformingWeight === -0 ? 0 : roundedNonConformingWeight,
  };
};
